import { createContext, type ReactNode } from 'react';

/**
 * Something that belongs to the panel without being inside its box: the
 * avatar-first gate's Ember line and Skip (13.11, first-ten-minutes pass,
 * 2026-10-22). A PanelSurface inside this context draws it above its scrim
 * and makes it part of the modal, so a finger and VoiceOver both reach it.
 * Drawn beside the panel instead, it sat under the scrim (a tap closed the
 * panel) and outside the aria-modal dialog (VoiceOver never reached it).
 */
export const PanelCompanionContext = createContext<ReactNode>(null);
